import store from '../store'
import moment from 'moment'
import { merge } from 'lodash'
import PGSHelper from '../helpers/PGSHelper.js';
import { V } from '../helpers/ValidationRules';

export default class Cliente {
    static typeSearch = "local" //online || local
    static rules = {
        Telefono: [(v) =>
            /^(|\d{1,10})$/.test(v) || "El numero de telefono debe ser de maximo 10 digitos"],
        Nombres: [
            V.required('El nombre es obligatorio'),
            V.minLength(2, 'El nombre debe tener al menos 2 caracteres'),
        ],
        Apellidos: [
            V.required('Los apellidos son obligatorios'),
            V.minLength(2, 'Los apellidos deben tener al menos 2 caracteres'),
        ],
        Correo: [
            V.email('Formato de email inválido'),
        ],
    }

    constructor(data = null) {
        this.Nombres = (data?.Nombres) ? data.Nombres : "";
        this.Apellidos = (data?.Apellidos) ? data.Apellidos : "";
        this.Correo = (data?.Correo) ? data.Correo : "";
        this.FechaNacimiento = (data?.FechaNacimiento) ? data.FechaNacimiento : "";
        this.Sexo = (data?.Sexo) ? data.Sexo : "";
        this.Cupones = (data?.Cupones) ? data.Cupones : [];
        this.DatosFiscales = (data?.DatosFiscales) ? data.DatosFiscales : [];
        this.ExtraData = (data?.ExtraData) ? data.ExtraData : null;
        this.FechaCreacion = (data?.FechaCreacion) ? data.FechaCreacion : null;
        this.Grupo = (data?.Id) ? data.Grupo : "";
        this.Apodo = (data?.Apodo) ? data.Apodo : "";
        this.hdcp = (data?.hdcp) ? data.hdcp : "";
        this.ghin = (data?.ghin) ? data.ghin : "";
        this.Fingerprint = (data?.Fingerprint) ? data.Fingerprint : "";
        this.ncnl = (data?.ncnl) ? data.ncnl : "";
        this.tipo = (data?.tipo) ? data.tipo : "";
        this.ulgj = (data?.ulgj) ? data.ulgj : "";
        this.clor = (data?.clor) ? data.clor : "";
        this.Monedero = (data?.Monedero) ? data.Monedero : { Saldo: 0, UMovimientos: [] };
        this.Telefonos = (data?.Telefonos) ? data.Telefonos : '';
        this.Telefono = (data?.Telefono) ? data.Telefono : "";
        this.CountryCode = (data?.CountryCode) ? data.CountryCode : "52";
        this.TelefonoAux = "";
        this.Tenant = (data?.Tenant) ? data.Tenant : store.getters.getFirebaseApp.tenant;
        this.Id = (data?.Id) ? data.Id : null;
        this.Code = ""
        this.Avatar = (data?.Avatar) ? data?.Avatar : false
        this.nots = (data?.nots) ? data?.nots : ""
        this.blqd = (data?.blqd) ? data?.blqd : false
    }

    static getRules() {
        return this.rules;
    }

    static getPropertyModel() {
        return this;
    }

    static getById(id) {
        /*if(this.typeSearch == "online"){
            let data = await store.getters.getFirebaseApp.firestore.collection("MBS_Membresias").doc(id).get();
            if(!data.exists){
                return false;
            }else{
                let doc = {Id:data.ref.id,...data.data()};
                return new Membresia(doc);
            }
        }else*/ if (this.typeSearch == "local") {
            let pgsHelper = new PGSHelper();
            let datos = pgsHelper.getById(store.getters["getClientes"], 'id', id);
            if (datos) { datos.Id = id; } else { return false }
            return new Cliente(datos);
        }
    }

    static getClientsList() {
        /*if(this.typeSearch == "online"){
            let data = await store.getters.getFirebaseApp.firestore.collection("MBS_Membresias")
            .where("Tenant", "==",store.getters.getFirebaseApp.tenant).get();
            if(data.empty){
                return [];
            }else{
                let doc = data.docs.map(doc=>{return {Id:doc.ref.id,...doc.data()}});
                let membresias = [];
                doc.forEach((documento)=>{
                    membresias.push(new Membresia(documento));
                })
                return membresias;
            }
        }else*/ if (this.typeSearch == "local") {
            let clientes = [];
            let localData = store.getters["getClientes"];
            localData.forEach((element) => {
                clientes.push(new Cliente({ Id: element.id, ...element }));
            })
            return clientes;
        }
    }

    getNombreCompleto() {
        let nombre = this.Nombres + " " + this.Apellidos
        nombre = nombre + ((this.Apodo) ? (' (' + this.Apodo + ')') : '');
        return nombre;
    }
}